import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: 'rm-medicine-detail',
  templateUrl: './medicine-detail.component.html',
  styleUrls: ['./medicine-detail.component.css']
})
export class MedicineDetailComponent implements OnInit {
  medicine: any;
  subscriptions: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private ebService: EventBusService,
    private globalCfgService: GlobalCfgService,
    private dialogRef: MatDialogRef<MedicineDetailComponent>,
  ) {}

  ngOnInit() {
      this.loadDetail(this.data.medicineId);
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadDetail(gtin) {

    var gcp = this.globalCfgService.getGcp();
    var obj = {
      gtin: gtin
    }

    if (gcp) {
      obj['gcp'] = gcp;
    }

    this.subscriptions.push(this.ebService.viewMedicineDetailValue$.subscribe(
      (detail)=> {
        this.medicine = detail;
      }
    ));

    this.ebService.getMedicineDetail(obj);
    

      // this.medicine = {
      //     name: 'Epilube',
      //     subName: 'Eye Drops',
      //     composition: 'Sodium Carboxymethyl Cellulose 0.5% Lubricant Eye Drops',
      //     location: 'Austrak, Badi, Himachal Pradesh, India',
      //     locationCnt: 3,
      //     batchesCnt: '3.14K',
      //     labelsCnt: '32.4K',
      //     roi: 78,
      //     img: '../../assets/uploads/austrack/med1.jpeg'
      // };
  }
  cancel(){
    this.dialogRef.close();
  }
}

export interface DialogData {
    medicineId: number;
  }